import { render, staticRenderFns } from "./VoteSlide.vue?vue&type=template&id=3e725895&scoped=true"
import script from "./VoteSlide.vue?vue&type=script&lang=js"
export * from "./VoteSlide.vue?vue&type=script&lang=js"
import style0 from "./VoteSlide.vue?vue&type=style&index=0&id=3e725895&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e725895",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/cmgames.septemberdev.nl/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e725895')) {
      api.createRecord('3e725895', component.options)
    } else {
      api.reload('3e725895', component.options)
    }
    module.hot.accept("./VoteSlide.vue?vue&type=template&id=3e725895&scoped=true", function () {
      api.rerender('3e725895', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/student/vue/slides/VoteSlide.vue"
export default component.exports